// How long one WhatsApp code keeps a computer signed in. Supabase renews the
// session on its own forever (no time box on mygaz-dev's plan), so the console
// counts the days itself and asks for a new code after SIGNED_IN_DAYS.

export const SIGNED_IN_DAYS = 30;
const KEY = 'mygaz-ops-signed-in-at';
const DAY_MS = 86_400_000;

/** True once a sign-in made at `at` (ms) is older than `days`. No date: not stale. */
export const isStale = (at: number | null, now: number, days = SIGNED_IN_DAYS) => at !== null && now - at > days * DAY_MS;

/** When this computer last typed a code, or null. */
export function signedInAt(): number | null {
  try {
    const v = Number(localStorage.getItem(KEY));
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch { return null; }
}

export function markSignedIn(now = Date.now()) {
  try { localStorage.setItem(KEY, String(now)); } catch { /* private window: the session ends with it */ }
}

export function forgetSignedIn() {
  try { localStorage.removeItem(KEY); } catch { /* private window */ }
}
